/**
 * Custom error class for popup authentication failures
 * This error occurs when MSAL popup authentication is blocked or cancelled by the user
 */
export class PopupAuthError extends Error {
  constructor(message: string = 'Popup authentication failed') {
    super(message);
    this.name = 'PopupAuthError';
    Object.setPrototypeOf(this, PopupAuthError.prototype);
  }
}
